export const normalizeTypologyLabel = (label) =>
  String(label === null || label === undefined ? "" : label)
    .toLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export const readLeadTypology = ({ resolved }) => {
  if (!resolved || typeof resolved !== "object")
    return { qualified: false, label: null };
  if (resolved.ignored === true) return null;

  const label =
    resolved.qualified === true &&
    typeof resolved.label === "string" &&
    resolved.label.trim()
      ? resolved.label
      : null;

  const rawLabel =
    typeof resolved.rawLabel === "string" && resolved.rawLabel.trim()
      ? resolved.rawLabel
      : null;

  return { qualified: Boolean(label), label, rawLabel };
};
